import React from 'react';
export const QueryClientContext = React.createContext(undefined);
export const useQueryClient = (queryClient) => {
    const client = React.useContext(QueryClientContext);
    if (queryClient) {
        return queryClient;
    }
    if (!client) {
        throw new Error('No QueryClient set, use QueryClientProvider to set one');
    }
    return client;
};
export const QueryClientProvider = ({ client, children }) => {
    React.useEffect(() => {
        client.mount();
        return () => {
            client.unmount();
        };
    }, [client]);
    return React.createElement(QueryClientContext.Provider, { value: client }, children);
};
//# sourceMappingURL=QueryClientContext.js.map